import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
// import CustomDropdown from "components/CustomDropdown/CustomDropdown.js";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import _ from "lodash";
import Datetime from "react-datetime";
import moment from "moment";
import Autocomplete from "react-autocomplete";
import duplicateUsername from "api/profile/duplicateUsername";
import searchCities from "api/profile/searchCities";

// import AutocompleteFavorite from "views/Profile/AutocompleteFavorite";

const autoCompleteStyle = {
  borderRadius: "3px",
  fontFamily: '"Archivo Narrow"',
  fontSize: "16px",
  lineHeight: "36px",
  backgroundColor: "#ffffff"
};

function renderItems(items) {
  return items.map((item, i) => (
    <div key={`autocomplete_${i.toString()}`}>{item}</div>
  ));
}

export default class EditProfileCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: _.cloneDeep(this.props.user, true),
      usernameAvailable: true,
      citiesList: []
    };

    this.timestamp = "";
    this.getInput = this.getInput.bind(this);
    // this.changeSex = this.changeSex.bind(this);
    this.getSex = this.getSex.bind(this);
    this.getInputUsername = this.getInputUsername.bind(this);
    this.getBirthDate = this.getBirthDate.bind(this);
    this.getLocality = this.getLocality.bind(this);
    this.saveEdit = this.saveEdit.bind(this);
    // this.getFavourites = this.getFavourites.bind(this);
    // this.changeFavourite = this.changeFavourite.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.user &&
      nextProps.user.profileId &&
      (!this.props.user || !this.props.user.profileId)
    ) {
      this.setState({ user: _.cloneDeep(nextProps.user, true) });
    }
    return true;
  }

  saveEdit() {
    const user = this.state.user;
    // controllo se ha cambiato locality e se va bene come è stata messa
    if (
      user.cityGeoname &&
      user.cityGeoname.city &&
      !user.cityGeoname.geonameId
    ) {
      if (this.state.citiesList && this.state.citiesList.length > 0) {
        const i = this.state.citiesList.findIndex(
          el => el.name === user.cityGeoname.city
        );
        if (i >= 0) {
          user.cityGeoname.geonameId = this.state.citiesList[i]._id;
        } else {
          user.cityGeoname = this.props.user.cityGeoname;
        }
      } else {
        user.cityGeoname = this.props.user.cityGeoname;
      }
    }
    // controllo che l'username è disponibile e più di tre caratteri
    if (
      user.username &&
      (user.username.length < 3 || !this.state.usernameAvailable)
    ) {
      user.username = this.props.user.username;
    }
    this.props.updateUser(user);
    this.setState({ user });
  }

  // changeSex(sex) {
  //   const user = this.state.user;
  //   if (sex.toLowerCase() === "male" || sex.toLowerCase() === "uomo") {
  //     user.gender = "male";
  //   } else if (
  //     sex.toLowerCase() === "female" ||
  //     sex.toLowerCase() === "donna"
  //   ) {
  //     user.gender = "female";
  //   } else {
  //     user.gender = "other";
  //   }
  //   this.setState({ user });
  // }

  getInput(type) {
    const t = this.props.t;
    return (
      <CustomInput
        labelText={t("inputLabels." + type)}
        inputProps={{
          value: this.state.user[type] || "",
          onChange: e => {
            const user = this.state.user;
            user[type] = e.target.value;
            this.setState({ user });
          },
          autoComplete: "off",
          multiline: type === "description" ? true : false
        }}
        id={type}
        formControlProps={{
          fullWidth: true
        }}
      />
    );
  }

  getInputUsername() {
    const { t } = this.props;
    return (
      <CustomInput
        labelText={t("inputLabels.username")}
        inputProps={{
          value: this.state.user.username || "",
          onChange: e => {
            const user = this.state.user;
            const newUsername = e.target.value;
            user.username = newUsername.replace(" ", "");
            if (newUsername.length > 2) {
              this.setState({ user });
              const timestamp = Date.now();
              this.timestamp = timestamp;
              duplicateUsername(newUsername, timestamp)
                .then(responseJson => {
                  if (
                    responseJson.timestamp.toString() ===
                    this.timestamp.toString()
                  ) {
                    if (responseJson.message === "duplicate username") {
                      if (user.username === this.props.user.username) {
                        this.setState({ usernameAvailable: true });
                      } else if (this.state.usernameAvailable) {
                        this.setState({ usernameAvailable: false });
                      }
                    } else {
                      if (this.state.usernameAvailable) {
                        // eslint-disable-next-line no-unused-expressions
                        null;
                      } else {
                        this.setState({ usernameAvailable: true });
                      }
                    }
                  }
                  // console.log("ResponseJSON username", responseJson, timestamp);
                  return null;
                })
                .catch(err => {
                  // eslint-disable-next-line no-console
                  console.log("err", err);
                  // if (user.username === this.props.user.username) {
                  //   this.setState({ user, usernameAvailable: true });
                  // } else if (this.state.usernameAvailable) {
                  //   this.setState({ user, usernameAvailable: false });
                  // } else {
                  //   this.setState({ user });
                  // }
                  return null;
                });
            } else {
              if (this.state.usernameAvailable) {
                this.setState({ usernameAvailable: false, user });
              } else {
                this.setState({ user });
              }
            }
          },
          autoComplete: "off",
          endAdornment:
            this.state.user.username &&
            this.state.user.username.length > 2 &&
            this.state.usernameAvailable ? (
              <InputAdornment position="end">
                <i
                  className="icon icon-check-24"
                  style={{ color: "#4caf50" }}
                />
              </InputAdornment>
            ) : (
              <InputAdornment position="end">
                <i
                  className="icon icon-cancel-24"
                  style={{ color: "#f44336" }}
                />
              </InputAdornment>
            )
        }}
        success={
          !!(
            this.state.user.username &&
            this.state.user.username.length > 2 &&
            this.state.usernameAvailable
          )
        }
        error={
          !!(
            !this.state.user.username ||
            this.state.user.username.length < 3 ||
            !this.state.usernameAvailable
          )
        }
        id={"username"}
        formControlProps={{
          fullWidth: true
        }}
      />
    );
  }

  getSex() {
    const { t, classes } = this.props;
    const user = this.state.user;
    return (
      <div>
        <div
          style={{
            fontSize: "17px",
            color: "#aaaaaa",
            marginTop: "20px"
          }}
        >
          {t("inputLabels.gender")}
        </div>
        <div
          style={{
            width: "100%",
            display: "inline-block",
            marginTop: "-10px"
          }}
        >
          <div
            style={{ float: "left", marginRight: "20px" }}
            className={classes.checkboxAndRadio}
          >
            <FormControlLabel
              style={{ marginRight: "0" }}
              control={
                <Checkbox
                  onClick={() => {
                    if (user.gender === "male") {
                      user.gender = "other";
                      this.setState({ user });
                    } else {
                      user.gender = "male";
                      this.setState({ user });
                    }
                  }}
                  color={"default"}
                  checked={user.gender === "male"}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
            />
            M
          </div>
          <div style={{ float: "left" }} className={classes.checkboxAndRadio}>
            <FormControlLabel
              style={{ marginRight: "0" }}
              control={
                <Checkbox
                  onClick={() => {
                    if (user.gender === "female") {
                      user.gender = "other";
                      this.setState({ user });
                    } else {
                      user.gender = "female";
                      this.setState({ user });
                    }
                  }}
                  color={"default"}
                  checked={user.gender === "female"}
                  classes={{
                    checked: classes.checked,
                    root: classes.checkRoot
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
            />
            F
          </div>
          {/* <div
            style={{
              float: "left",
              lineHeight: "46px",
              marginRight: "20px",
              fontSize: "17px",
              color: "#aaaaaa"
            }}
          >
            {t("inputLabels.gender")}
          </div>
          <div style={{ float: "left", maxWidth: "100px" }}>
            <CustomDropdown
              hoverColor="info"
              buttonText={t("editProfile." + user.gender || "other")}
              onClick={e => {
                this.changeSex(e);
              }}
              buttonProps={{
                round: true,
                fullWidth: true,
                style: { marginBottom: "0" },
                color: "info"
              }}
              dropdownHeader={t("inputLabels.gender")}
              dropdownList={[
                t("editProfile.male"),
                t("editProfile.female"),
                t("editProfile.other")
              ]}
            />
          </div> */}
        </div>
      </div>
    );
  }

  // changeFavourite(el, type, attribute) {
  //   const user = this.state.user;
  //   const { attributes, language } = this.props;
  //   let newEl = {};
  //   const i = attributes[attribute].findIndex(
  //     att => att[`label_${language || "it"}`] === el
  //   );
  //   if (i >= 0) {
  //     newEl = attributes[attribute][i];
  //   }
  //   user[type] = {
  //     label_it: newEl.label_it,
  //     label_en: newEl.label_en,
  //     _id: newEl._id
  //   };
  //   this.setState({ user });
  // }

  // getFavourites(type) {
  //   const { t, attributes, language } = this.props;
  //   const user = this.state.user;
  //   let options = [];
  //   let attribute = "";
  //   if (type === "favouriteCuisine") {
  //     options = attributes.categories.map(
  //       el => el[`label_${language || "it"}`]
  //     );
  //     attribute = "categories";
  //   } else if (type === "idealCompany") {
  //     options = attributes.idealEvents.map(
  //       el => el[`label_${language || "it"}`]
  //     );
  //     attribute = "idealEvents";
  //   }
  //   return (
  //     <div
  //       style={{
  //         width: "100%",
  //         display: "inline-block",
  //         marginTop: "10px"
  //       }}
  //     >
  //       <div
  //         style={{
  //           float: "left",
  //           lineHeight: "46px",
  //           marginRight: "20px",
  //           fontSize: "17px",
  //           color: "#aaaaaa"
  //         }}
  //       >
  //         {t("inputLabels." + type)}
  //       </div>
  //       <div style={{ float: "left", maxWidth: "100px" }}>
  //         <CustomDropdown
  //           hoverColor="info"
  //           buttonText={user[type][`label_${language || "it"}`] || "not set"}
  //           onClick={e => {
  //             this.changeFavourite(e, type, attribute);
  //           }}
  //           buttonProps={{
  //             round: true,
  //             fullWidth: true,
  //             style: { marginBottom: "0" },
  //             color: "info"
  //           }}
  //           dropdownHeader={t("inputLabels." + type)}
  //           dropdownList={options}
  //         />
  //       </div>
  //     </div>
  //   );
  // }

  getBirthDate() {
    const { t } = this.props;
    const user = this.state.user;
    const dateDay = moment(user.birthDate)
      .format("DD")
      .toString();
    const dateMonth = t(
      moment(user.birthDate)
        .format("MMM")
        .toString()
        .toLowerCase()
    );
    const dateYear = moment(user.birthDate)
      .format("YYYY")
      .toString();
    const date = `${dateDay} ${dateMonth} ${dateYear}`;
    const now = new Date();
    return (
      <div
        style={{
          width: "100%",
          display: "inline-block",
          marginBottom: "20px",
          marginTop: "20px"
        }}
      >
        <div
          style={{
            lineHeight: "20px",
            color: "#aaaaaa",
            fontSize: "17px"
          }}
        >
          {t("inputLabels.birthDate")}
        </div>
        <div
          style={
            {
              /* float: "left", maxWidth: "150px" */
            }
          }
        >
          <Datetime
            inputProps={{
              placeholder: t("inputLabels.date"),
              style: {
                fontFamily: "'Archivo Narrow', sans-serif",
                width: "150px",
                height: "45px",
                fontSize: "17px"
              }
            }}
            color={"default"}
            closeOnSelect
            timeFormat={false}
            isValidDate={current => {
              return moment(current).isBefore(moment(now));
            }}
            value={date}
            onChange={e => {
              user.birthDate = moment(e).format();
              this.setState({ user });
            }}
          />
        </div>
      </div>
    );
  }

  selectCity(city) {
    const citiesList = this.state.citiesList;
    const i = citiesList.findIndex(el => el.name === city);
    if (i >= 0) {
      const user = this.state.user;
      user.cityGeoname.city = city;
      user.cityGeoname.geonameId = citiesList[i]._id;
      this.setState({ user });
    }
  }

  getLocality() {
    const { t } = this.props;
    const user = this.state.user;
    const items = this.state.citiesList.map(city => {
      const item = {};
      item.label = city.name;
      return item;
    });
    return (
      <div
        style={{
          width: "100%",
          marginBottom: "10px",
          marginTop: "20px"
        }}
      >
        {user && user.cityGeoname && user.cityGeoname.city ? (
          <div
            style={{
              lineHeight: "1.42857",
              fontSize: "12px",
              color: "#aaaaaa"
            }}
          >
            {t("inputLabels.locality")}
          </div>
        ) : null}
        <div style={{ position: "relative" }}>
          <Autocomplete
            wrapperStyle={autoCompleteStyle}
            inputProps={{
              placeholder: t("inputLabels.locality"),
              className: "about-cuisine-foodtype-input",
              style: { fontSize: "18px" }
              // onKeyDown: e => {
              //   if (e.key === "Enter") {
              //     console.log("faccio qualcosa");
              //   }
              // }
            }}
            menuStyle={{ width: "50%" }}
            getItemValue={item => item.label}
            shouldItemRender={(item, value) => {
              const bool = item.label
                .toLowerCase()
                .includes(value.toLowerCase());
              return bool;
            }}
            items={items}
            renderItem={(item, isHighlighted) => (
              <div
                style={{
                  color: isHighlighted ? "#0094df" : "#4a4a4a",
                  fontSize: "18px",
                  fontFamily: '"Archivo Narrow"',
                  padding: "0px 10px",
                  fontWeight: 600
                }}
              >
                {item.label}
              </div>
            )}
            value={
              user.cityGeoname && user.cityGeoname.city
                ? user.cityGeoname.city
                : ""
            }
            onChange={e => {
              const timestamp = Date.now();
              this.timestamp = timestamp;
              if (!user.cityGeoname) {
                user.cityGeoname = {};
              }
              user.cityGeoname.city = e.target.value;
              user.cityGeoname.geonameId = "";
              this.setState({ user });
              if (e.target.value.length > 2) {
                searchCities(
                  e.target.value,
                  this.props.language || "it",
                  "0",
                  "0",
                  timestamp
                )
                  .then(responseJson => {
                    if (
                      responseJson.timestamp.toString() ===
                        this.timestamp.toString() &&
                      responseJson.results
                    ) {
                      // console.log("responseJson", responseJson);
                      this.setState({ citiesList: responseJson.results });
                    }
                    return null;
                  })
                  .catch(err => {
                    // eslint-disable-next-line no-console
                    console.log("err", err);
                    return null;
                  });
              }
            }}
            onSelect={val => {
              this.selectCity(val);
            }}
            renderMenu={(items, value) => (
              <div style={{ display: "block" }}>
                {value === "" ? (
                  <div
                    style={{ padding: "0 8px", fontSize: "18px" }}
                    className="autocomplete-foodtype-list"
                  >
                    {t("editProfile.add_locality")}
                  </div>
                ) : items.length === 0 ? (
                  <div
                    className="autocomplete-foodtype-list"
                    style={{ fontSize: "18px", padding: "0 10px" }}
                  >
                    {t("editProfile.city_not_found")}
                  </div>
                ) : (
                  <div className="autocomplete-foodtype-list">
                    {renderItems(items)}
                  </div>
                )}
              </div>
            )}
          />
        </div>
      </div>
    );
  }

  render() {
    const { classes, t, user, language, attributes } = this.props;
    // if (!user || !user.profileId) {
    //   return null;
    // }
    return (
      <Card>
        <CardHeader color="warning" stats icon>
          <CardIcon
            style={{
              backgroundImage: "linear-gradient(to right, #ec407a, #d81b60)",
              boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.14)"
            }}
            color="warning"
          >
            <i
              style={{ fontSize: "25px" }}
              className={"icon icon-foodies-24"}
            />
          </CardIcon>
          <p className="dashboard-restaurant-card-name">
            {t("editProfile.edit_profile")}
            <span style={{ fontSize: "20px", color: "#d9d9d9" }}>
              {" - "}
              {t("editProfile.complete_profile")}
            </span>
          </p>
        </CardHeader>
        <CardBody>
          {this.getInputUsername()}
          {this.getInput("firstName")}
          {this.getInput("middleName")}
          {this.getInput("lastName")}
          <GridContainer>
            <GridItem xs={12} sm={6}>
              {this.getBirthDate()}
            </GridItem>
            <GridItem xs={12} sm={6}>
              {this.getSex()}
            </GridItem>
          </GridContainer>
          {/* {this.getLocality()} */}
          {this.getInput("description")}
          {/* {this.getFavourites("favouriteCuisine")} */}
        </CardBody>
        <CardFooter stats>
          <div
            style={{
              width: "100%",
              display: "inline-block",
              marginTop: "10px"
            }}
          >
            <Button
              color="rose"
              round
              className={classes.marginRight}
              style={{ fontFamily: "'Archivo Narrow'", float: "right" }}
              onClick={() => {
                this.saveEdit();
              }}
            >
              {t("editProfile.update_profile").toUpperCase()}
            </Button>
          </div>
        </CardFooter>
      </Card>
    );
  }
}

EditProfileCard.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  updateUser: PropTypes.func.isRequired,
  attributes: PropTypes.object.isRequired
};

// export default withStyles(registerPageStyle)(EditProfileCard);
